import { useMemo } from 'react'

import { form } from '../formState'

export function useShowPhoneAlert() {
  const automatedMessageEnabled = form.useFormField('automatedMessageEnabled')
  const callbackConfigStatus = form.useFormField('callbackConfigStatus')
  const status = form.useFormField('status')

  return useMemo(
    () =>
      status.field.value === 'ADVANCED' &&
      callbackConfigStatus.field.value === 'OFF' &&
      automatedMessageEnabled.field.value === 'ON',
    [automatedMessageEnabled.field.value, callbackConfigStatus.field.value, status.field.value],
  )
}
